import { API_BASE_URL, apiUrl, parseJsonResponse } from './apiConfig'

async function fetchWithTimeout(resource, options = {}, timeout = 30000) {
  const controller = new AbortController()
  const id = setTimeout(() => {
    console.warn(`Request timeout after ${timeout}ms for: ${resource}`)
    controller.abort()
  }, timeout)
  try {
    console.log(`Fetching: ${resource}`)
    const response = await fetch(resource, {
      ...options,
      signal: controller.signal,
    })
    clearTimeout(id)
    return response
  } catch (error) {
    clearTimeout(id)
    if (error.name === 'AbortError') {
      console.error(`Request aborted (timeout): ${resource}`)
      throw new Error(`Request timeout. Backend not responding. Check if server is running at ${API_BASE_URL}`)
    }
    throw error
  }
}

export async function fetchEmployees(query = '') {
  const url = apiUrl('/employees/active', { search: query })

  console.log('Fetching employees from:', url.toString())
  const response = await fetchWithTimeout(url.toString(), {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }, 30000)

  console.log('Employee fetch response status:', response.status)

  const data = await parseJsonResponse(response, 'Failed to fetch employees')
  const employees = Array.isArray(data) ? data : data?.employees || []
  console.log('Employees fetched successfully, count:', employees.length)

  return employees
}

export async function registerVisitor(data) {
  const response = await fetchWithTimeout(`${API_BASE_URL}/visitors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.error || error.message || 'Registration failed. Please try again.')
  }

  return parseJsonResponse(response, 'Registration failed. Please try again.')
}

export async function getVisitors(status = '') {
  const url = apiUrl('/visitors', { status })

  const response = await fetchWithTimeout(url.toString(), {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }, 15000)

  if (!response.ok) {
    throw new Error('Failed to fetch visitors')
  }

  return parseJsonResponse(response, 'Failed to fetch visitors')
}
